import './calendarNote.scss';
import WeekNumberCalender from './weekNumberCalender/weekNumberCalender';
import WithSidebarAndNavBar from '../../layouts/withSideBarAndNavBar/withSideBarAndNavBar';
import SelectionToggle from './selectionToggle/selectionToggle';
import StartDaySelection from './startDaySelection/StartDaySelection';
import EmployerSelection from './employerSelection/employerSelection';
import { useState } from 'react';
import EmployerCalender from './employerCalender/employerCalender';
import SideDrawer from './sideDrawer/sideDrawer';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';

const calendarNote = () => {
  const [state, setState] = useState<number>(1);
  const [drawerData, setDrawerData] = useState<{
    id?: number;
    startTime?: number;
    endTime?: number;
    date?: string;
  }>({
    id: undefined,
    startTime: undefined,
    endTime: undefined,
    date: undefined,
  });

  return (
    <WithSidebarAndNavBar>
      <div className="calendarNoteScreen">
        <div className="content">
          <div className="header">일정관리</div>

          <div className="controllerRow">
            <div className="leftPart">
              <div className="dateDropDownWrapper">
                <StartDaySelection />
              </div>
              <div className="personDropDownWrapper">
                <EmployerSelection />
              </div>
            </div>
            <div className="rightPart">
              <SelectionToggle
                getSelection={(e) => {
                  setState(e);
                }}
              />
            </div>
          </div>

          {state == 1 ? (
            <WeekNumberCalender
              onTabClick={(data) => {
                setDrawerData({
                  id: data.id,
                  startTime: data.startTime,
                  endTime: data.endTime,
                  date: data.date,
                });
              }}
            />
          ) : (
            <></>
          )}
          {state == 2 ? (
            <EmployerCalender
              onTabClick={(data) => {
                // setDrawerData({ id: data.id, startTime: data.startTime, endTime: data.endTime });
              }}
            />
          ) : (
            <></>
          )}

          {/* drawer */}
          {drawerData.id != undefined ? (
            <SideDrawer
              onClose={() => {
                setDrawerData({
                  id: undefined,
                  startTime: undefined,
                  endTime: undefined,
                });
              }}
            />
          ) : (
            <></>
          )}

          {state == 3 ? (
            <FullCalendar
              plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
              headerToolbar={{
                left: '',
                center: '',
                right: '',
              }}
              locale="ko"
              initialView="dayGridMonth"
              editable={true}
              selectable={true}
              selectMirror={true}
              dayMaxEvents={true}
              weekends={true}
            />
          ) : (
            <></>
          )}
        </div>
      </div>
    </WithSidebarAndNavBar>
  );
};

export default calendarNote;
